// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N26s","col":"styles_col__3xyyR","actions":"styles_actions__2UuoN","conflict":"styles_conflict__1QECO"};